module.exports = __webpack_public_path__ + "static/media/Lateral_NES_Z2.706b3d83.png";